<script>
import { mapState } from 'vuex';
export default {
    name: "contactUs",
    data() {
        return {
            name: '',
            phone: '',
            email: '',
            address: '',
            content: '',
            theme: '',
            isLoading: false,
        };
    },
    computed: {
        ...mapState(['contactData'])
    },
    components: {
        
    },
    mounted() {
        this.$store.dispatch('getContactUs');
    },
    destroyed() {},
    watch: {},
    methods: {
        submit() {
            if(this.isLoading){
                return false;
            }
            if(this.name.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.name.focus();
                this.$showToast({ text: '请输入姓名' }); //
                // this.$showToast({ text: 'Please enter name' }); //请输入姓名
                return false;
            }
            if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.phone.focus();
                this.$showToast({ text: '请输入手机号' }); //请输入邮箱
                return false;
            }
            if(this.email.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.email.focus();
                this.$showToast({ text: '请输入邮箱' }); //请输入邮箱
                return false;
            }
            if(!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email))){
                this.$refs.email.focus();
                this.$showToast({ text: '邮箱格式有误' }); //邮箱格式有误
                return false;
            }
            if(this.address.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.address.focus();
                this.$showToast({ text: '请输入地址' }); //请输入邮箱
                return false;
            }
            if(this.theme.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.theme.focus();
                this.$showToast({ text: '请输入主题' }); //请输入邮箱
                return false;
            }
            if(this.content.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.content.focus();
                this.$showToast({ text: '请输入留言' }); //请输入邮箱
                return false;
            }
            this.isLoading = true;
            this.$showLoading();
            this.$store.dispatch('submitMessage', {
                type: '联系我们',
                name: this.name,
                email: this.email,
                phone: this.phone,
                address: this.address,
                message: this.content,
                theme: this.theme,
            }).then((result) => {
                this.isLoading = false;
                this.$hideLoading();
                if (result.code == 100) { 
                    this.$showToast({ text: '上传成功' });
                    this.name = '';
                    this.email = '';
                    this.phone = '';
                    this.address = '';
                    this.theme = '';
                    this.content = '';
                } else {
                    this.$showToast({ text: '上传失败' });
                }
            }).catch((err) => {
                this.isLoading = false;
                this.$showToast({ text: '上传失败' });
            });
        }
    },
};
</script>

<template>
    <div class="contactUs layout_body">
        <!-- banner -->
        <div class="banner">
            <div class="layout_bg bg" :style="`background-image: url(${contactData.banner});`"></div>
        </div>
        <div class="layout_main">
            <div class="layout_content wrapper">
                <div class="title">联系我们</div>
                <div class="list flex flex_wrap justify_between">
                    <div class="item" v-for="(item, index) in contactData.list" :key="index">
                        <div class="name layout_flex_center">{{ item.name }}</div>
                        <div class="tel" v-if="item.phone">请致电：<a :href="`tel:+${item.phone}`">{{ item.phone }}</a></div>
                        <div class="email" v-if="item.email">E-mail：<a :href="`mailto:${item.email}`">{{ item.email }}</a></div>
                    </div>
                    <div class="form">
                        <div class="name">留言</div>
                        <div class="input_group">
                            <input type="text" ref="name" v-model="name" placeholder="姓名"/>
                            <input type="tel" ref="phone" v-model="phone" placeholder="手机号"/>
                        </div>
                        <div class="input_group">
                            <input type="text" ref="email" v-model="email" placeholder="E-mail"/>
                            <input type="text" ref="address" v-model="address" placeholder="地址"/>
                        </div>
                        <div class="input_group">
                            <input type="text" ref="theme" v-model="theme" placeholder="主题"/>
                        </div>
                        <div class="input_group">
                            <textarea ref="content" v-model="content" placeholder="留言"></textarea>
                        </div>
                        <div class="input_group justify_end">
                            <div class="btn layout_flex_center" @click="submit">提交</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    width: 100%;
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 6.3rem;
    }
}
.wrapper{
    @media only screen and (max-width: 750px) {
        padding: 0;
    }
    .title{
        font-size: .25rem;
        padding: .2rem 0 .4rem;
        @media only screen and (max-width: 750px) {
            font-size: .36rem;
            text-align: center;
            padding: .4rem 0 .8rem;
            font-weight: bold;
        }
    }
    .list{
        .item{
            width: 3.2rem;
            margin-bottom: .5rem;
            .name{
                font-size: .2rem;
                margin-bottom: .2rem;
                height: .4rem;
                border: 1px solid #666666;
                color: #666666;
            }
            .tel,
            .email{
                font-size: .18rem;
                white-space: nowrap;
            }
        }
        @media only screen and (max-width: 750px) {
            flex-direction: column;
            align-items: center;
            .item{
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .name{
                    width: 3.2rem;
                    height: .5rem;
                    font-size: .28rem;
                    margin-bottom: .4rem;
                }
                .tel,
                .email{
                    font-size: .28rem;
                    line-height: 1.8;
                }
            }
        }
    }
    .form{
        width: 7.2rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
        .name{
            font-size: .2rem;
            color: #666;
            margin-bottom: .2rem;
            @media only screen and (max-width: 750px) {
                font-size: .36rem;
                text-align: center;
                color: var(--font_color);
                font-weight: bold;
                margin-bottom: .4rem;
            }
        }
        .input_group{
            width: 100%;
            display: flex;
            gap: .24rem;
            margin-bottom: .24rem;
            input,
            textarea,
            .btn{
                width: 0;
                flex: 1;
                height: .4rem;
                font-size: .2rem;
                border: 1px solid #666;
                padding: 0 .15rem;
                box-sizing: border-box;
                &::placeholder{
                    color: #999999;
                }
            }
            textarea{
                height: 1.7rem;
                padding: .1rem .15rem;
            }
            .btn{
                flex: none;
                width: .9rem;
                cursor: pointer;
            }
            @media only screen and (max-width: 750px) {
                gap: .3rem;
                input,
                textarea,
                .btn{
                    height: .68rem;
                    font-size: .28rem;
                    padding: 0 .2rem;
                    // padding: 0;
                }
                textarea{
                    height: 2.7rem;
                    padding: .2rem;
                }
                .btn{
                    width: 1.2rem;
                }
            }
        }
    }
}
</style>